// 用户资料
const state = {
  userInfo:{}
}

const mutations = {
  setUserKey(state, { key, value }) {
    state[key] = value
  }
}

const actions = {

}

const getters = {
  userInfo: state => state.userInfo
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
